export function apiOrigin(configured) {
  return (configured || "https://sayyadi-api.onrender.com").replace(/\/+$/, "");
}
export const BACKEND_URL = apiOrigin(process.env.REACT_APP_BACKEND_URL);
export const API_BASE = `${BACKEND_URL}/api`;
